import React from "react";
import CatagoryPreview from "../CatagoryPreview/CatagoryPreview";
import "./CatagoriesPreview.scss";

const CatagoriesPreview = (props) => {
  return (
    <div className="CatagoriesPreview">
      <h1>Discover</h1>
      <CatagoryPreview title="BEDS" />
      <CatagoryPreview title="MATTRESS" />
      <CatagoryPreview title="FURNITURE" />
    </div>
  );
};

export default CatagoriesPreview;
